module.exports = __webpack_public_path__ + "media/icons/rubber-7ca86339.png";